import { useGetVersionUrlsQuery } from 'features/publications/publicationApi';

const defaultUrls = { htmlUrl: '', pdfUrl: '', printPdfUrl: '' };

/**
 * @param {string} [versionUri]
 * @returns {{
 *     htmlUrl: string | null,
 *     pdfUrl: string | null,
 *     printPdfUrl: string | null,
 * }}
 */
export function useGetVersionUrls(versionUri) {
    const versionUrls = useGetVersionUrlsQuery(versionUri, {
        skip: !versionUri,
        selectFromResult: ({ data }) => ({
            urls: data ?? defaultUrls,
        }),
    });

    return versionUrls.urls;
}
